import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const ChapterNext = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='ChapterNext' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M1,3.5 L1,20 L10,14 L10,20 L21,12 L10,4 L10,10 L1,3.5 Z M22,2 L22,22 L22,2 Z' />
  </StyledIcon>
);
